import { render, staticRenderFns } from "./ci_icon.vue.js?vue&type=template&id=6febd8a2!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_icon.vue?vue&type=template&id=6febd8a2"
import script from "./ci_icon.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_icon.vue?vue&type=script&lang=js"
export * from "./ci_icon.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6febd8a2')) {
      api.createRecord('6febd8a2', component.options)
    } else {
      api.reload('6febd8a2', component.options)
    }
    module.hot.accept("./ci_icon.vue.js?vue&type=template&id=6febd8a2!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_icon.vue?vue&type=template&id=6febd8a2", function () {
      api.rerender('6febd8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/ci_icon/ci_icon.vue"
export default component.exports